import React, { useState } from 'react';
import Papa from 'papaparse';
import axios from 'axios';
import GLOBALVAR from '../constants'; // Import GLOBALVAR constant

const ImportLoanProcessing = () => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleImport = () => {
    if (!file) {
      alert('Please select a file first!');
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const data = results.data;

        for (let row of data) {
          try {
            // Check if the applicant exists in the Applications database
            const checkResponse = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/applications/check`, {
              params: {
                firstName: row['First Name'],
                lastName: row['Last Name']
              }
            });

            if (checkResponse.data.exists) {
              const applicantID = checkResponse.data.id;

              // Check if there are existing loan processing records for this applicant
              const existingLoanResponse = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/check`, {
                params: {
                  applicantID: applicantID,
                  dateGranted: row['Loan Date'] || '1900-01-01',
                  amountGranted: parseFloat(row['Loan Amount']) || 0
                }
              });

              // Determine loanProcessingType based on existing records
              const loanProcessingType = existingLoanResponse.data.exists && !existingLoanResponse.data.match ? 'reloan' : 'new';

              // Prepare the payload for the API
              const payload = {
                loanProcessingType: loanProcessingType,
                amountGranted: parseFloat(row['Loan Amount']) || 0,
                dateGranted: row['Loan Date'] || '1900-01-01', // Placeholder date
                interestRate: (parseFloat(row['Interest Amount Per Month']) / parseFloat(row['Loan Amount'])) * 100 || 0,
                loanTerm: parseInt(row['Payment Terms (Months)']) || 0,
                paymentType: 'add',
                loanInterval: 'monthly',
                accountOfficer: 'Placeholder Account Officer',
                loanProduct: 'Placeholder Loan Product',
                loanLedger: 'Placeholder Loan Ledger',
                loanSecurity: 'Placeholder Loan Security',
                reference: row['Referral'] || 'Placeholder Reference',
                loanType: 'personal',
                addtl_beneficiary: 'Placeholder Additional Beneficiary',
                addtl_contact: 'Placeholder Additional Contact',
                addtl_relationship: 'Placeholder Additional Relationship',
                is_deleted: false,
                applicantID: applicantID // Set the applicantID
              };

              if (existingLoanResponse.data.match) {
                // Update existing loan processing entry if dateGranted and amount match
                const updateResponse = await axios.post(
                  `${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/update/${existingLoanResponse.data.id}`,
                  payload
                );
                console.log('Loan processing entry updated successfully!', updateResponse.data);
              } else {
                // Create new loan processing entry
                const createResponse = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/loan-processing/add`, payload);
                console.log('Loan processing entry added successfully!', createResponse.data);
              }
            } else {
              console.warn(`Applicant ${row['First Name']} ${row['Last Name']} not found in Applications database.`);
            }
          } catch (error) {
            console.error('Error processing loan entry:', error);
          }
        }

        alert('CSV import complete!');
      }
    });
  };

  return (
    <div>
      <h1>CSV Import</h1>
      <input type="file" accept=".csv" onChange={handleFileChange} />
      <button onClick={handleImport}>Import CSV</button>
    </div>
  );
};

export default ImportLoanProcessing;